// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"_3bf50c88"};